module.exports = __webpack_public_path__ + "static/img/3.7af7ac87.png";